module.exports = __webpack_public_path__ + "static/11-957327fb2e75d058956ac130253a2db3.jpg";